import MedicationsList from './MedicationsList';

export default MedicationsList;


// WEBPACK FOOTER //
// ./src/components/Pages/Health/MedicationsList/index.js